import {
  ViewEncapsulation,
  Component,
  Inject,
  ViewChild,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { UserModel } from "../../models/user/user.model";
import {
  MdDialogRef,
  MD_DIALOG_DATA,
  MdPaginator,
  MD_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY,
} from "@angular/material";
import { DataSource } from "@angular/cdk/collections";
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { DizionarioSearchModel } from "../../models/shared/dizionarioSearch.model";
import { Observable } from "rxjs/Observable";
import { AuthService } from "../../services/auth.service";
import { SharedService } from "../../services/shared.service";
import { Subscription } from "rxjs/Subscription";
import * as _ from "lodash";

export class ScegliZonaUVModel {
  // riferimento, da lasciare invariato! è competenza del chiamante
  constructor(public utenteRef: UserModel) {}
}

@Component({
  selector: "scegli-zona",
  moduleId: module.id,
  templateUrl: "scegliZonaUV.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./ScegliZonaUV.component.css"],
})
export class ScegliZonaUVDialog implements OnInit, OnDestroy {
  modelUV: DizionarioSearchModel = null;
  modelZone: DizionarioSearchModel = null;
  isLoading: Boolean = false;
  private utenteCorrente: UserModel;
  public zonaScelta?: string;
  @ViewChild(MdPaginator) paginatorUV: MdPaginator;
  @ViewChild(MdPaginator) paginatorZone: MdPaginator;
  dataSourceUV: UnitaVenditaDataSource = null;
  codiceUVScelta: string = null;
  codiceZonaScelta: string = null;
  displayedColumnsUV = ["codice", "descrizione"];
  displayedColumnsZone = ["codice", "descrizione"];
  dataSourceZone: ZoneUnitaVenditaDataSource = null;
  unitaVenditaTrovate: DizionarioModel[];
  zoneUnitaVenditaTrovate: DizionarioModel[];
  numeroRisultati: number = 0;
  isRefreshing = false;
  public toClose: boolean = false;

  subscription: Subscription;

  constructor(
    public dialogRef: MdDialogRef<ScegliZonaUVDialog>,
    @Inject(MD_DIALOG_DATA) public data: ScegliZonaUVModel,
    private authService: AuthService,
    private _sharedService: SharedService
  ) {
    this.utenteCorrente = data.utenteRef;
    dialogRef.disableClose = true;
  }
  ngOnInit() {
    this.modelUV = new DizionarioSearchModel();
    this.modelZone = new DizionarioSearchModel();
    this.isLoading = true;
    // if (this._sharedService.uvZoneLoaded.value) {
    if (this.getUvZone()) {
      const res = this.getUvZone();
      this.dataSourceUV = new UnitaVenditaDataSource(
        res,
        this.paginatorUV,
        this.modelUV
      );
      this.isLoading = false;
    } else {
      this.isLoading = true;
      this.subscription = this._sharedService.uvZoneLoaded.subscribe((list) => {
        if (!list) {
          this.isLoading = true;
        }
        const res = this.getUvZone();
        this.dataSourceUV = new UnitaVenditaDataSource(
          res,
          this.paginatorUV,
          this.modelUV
        );
        if (list) {
          this.isLoading = false;
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getUvZone() {
    // const listaUnitaVendita = JSON.parse(
    //   localStorage.getItem("listaUnitaVendita")
    // );
    // return _.orderBy(listaUnitaVendita, ["descrizione"]);
    return JSON.parse(localStorage.getItem("listaUnitaVendita"));
  }

  start() {
    /*
    this.authService.listaUnitaVendita().subscribe((r:DizionarioModel[])=>{
      this.dataSourceUV=new UnitaVenditaDataSource(r,this.paginatorUV,this.modelUV);
      this.isLoading=false;
    });
    */
    this.isLoading = true;
    const res = this.getUvZone();
    this.dataSourceUV = new UnitaVenditaDataSource(
      res,
      this.paginatorUV,
      this.modelUV
    );
    if (res) {
      this.isLoading = false;
    }
  }
  updateUV() {
    if (this.codiceUVScelta != null) {
      this.isRefreshing = true;
      this.authService
        .listaZoneUnitaVendita(this.codiceUVScelta)
        .subscribe((r: DizionarioModel[]) => {
          this.dataSourceZone = new ZoneUnitaVenditaDataSource(
            r,
            this.paginatorZone,
            this.modelZone
          );
          this.isRefreshing = false;
        });
    } else {
      this.dataSourceZone = new ZoneUnitaVenditaDataSource(
        [],
        this.paginatorZone,
        this.modelZone
      );
    }
  }
  ConfermaZonaUV() {
    this.utenteCorrente.chosenZona = this.codiceZonaScelta;
    this.utenteCorrente.chosenUV = this.codiceUVScelta;
    this._sharedService.setUVZona({
      uv: this.codiceUVScelta,
      zona: this.codiceZonaScelta,
    });

    localStorage.setItem("currentUser", JSON.stringify(this.utenteCorrente));
    this.toClose = true;
    this.dialogRef.close();
  }
  impostaZona(codiceZona: string) {
    this.codiceZonaScelta = codiceZona;
  }
  impostaUnitaVendita(codiceUV: string) {
    this.codiceUVScelta = codiceUV;
    this.updateUV();
  }
  cambiaUVScelta() {
    this.codiceUVScelta = null;
    this.codiceZonaScelta = null;
  }
  cambiaZonaScelta() {
    this.codiceZonaScelta = null;
  }
}

export class UnitaVenditaDataSource extends DataSource<any> {
  constructor(
    private data: DizionarioModel[],
    private _paginator: MdPaginator,
    private model: DizionarioSearchModel
  ) {
    super();
  }
  connect(): Observable<DizionarioModel[]> {
    return Observable.of(this.data);
  }

  disconnect() {}
}

export class ZoneUnitaVenditaDataSource extends DataSource<any> {
  constructor(
    private data: DizionarioModel[],
    private _paginator: MdPaginator,
    private model: DizionarioModel
  ) {
    super();
  }
  connect(): Observable<DizionarioModel[]> {
    return Observable.of(this.data);
  }

  disconnect() {}
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/layout/ScegliZonaUV.component.ts